import { useRef, useEffect } from 'react';

const SERVICES = [
  {
    icon: 'ri-shield-check-line',
    title: 'Orientação Jurídica Preventiva',
    desc: 'Identificação e prevenção de riscos jurídicos antes que se tornem problemas. Análise antecipada para proteger seus interesses com segurança.',
  },
  {
    icon: 'ri-alert-line',
    title: 'Análise de Riscos',
    desc: 'Avaliação técnica e criteriosa dos riscos envolvidos em cada situação, com diagnóstico claro e objetivo para a tomada de decisão.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Suporte na Tomada de Decisões',
    desc: 'Apoio jurídico qualificado para decisões estratégicas, com visão analítica e orientação precisa sobre o cenário jurídico.',
  },
  {
    icon: 'ri-user-check-line',
    title: 'Atendimento Personalizado',
    desc: 'Cada cliente recebe atenção exclusiva e tratamento diferenciado, com comunicação clara e acompanhamento próximo do advogado.',
  },
];

export default function ConsultingSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );
    const children = sectionRef.current?.querySelectorAll('.animate-card');
    children?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="consultoria" className="py-32 bg-[#1F4B63] relative overflow-hidden" ref={sectionRef}>
      {/* Background Texture */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#C6935A] rounded-full -translate-y-1/2 translate-x-1/2" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#D4A873] rounded-full translate-y-1/2 -translate-x-1/2" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 animate-card opacity-0 translate-y-8 transition-all duration-700">
          <p className="text-[#D4A873] text-xs font-600 tracking-[3px] uppercase mb-4">
            Nossos Serviços
          </p>
          <h2 className="text-4xl lg:text-5xl font-700 text-white leading-tight mb-6">
            Consultoria Jurídica
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto leading-relaxed">
            Soluções jurídicas especializadas com análise técnica aprofundada e foco na segurança das suas decisões.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service, i) => (
            <div
              key={service.title}
              className="animate-card opacity-0 translate-y-8 transition-all duration-700 group"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="bg-white/8 hover:bg-white/12 border border-white/10 hover:border-[#C6935A]/40 rounded-xl p-8 h-full transition-all duration-300 hover:-translate-y-2 cursor-default flex flex-col items-center text-center">
                {/* Content */}
                <h3 className="text-white font-600 text-xl mb-4 leading-tight">{service.title}</h3>
                <p className="text-white/65 text-sm leading-relaxed">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-14 animate-card opacity-0 translate-y-8 transition-all duration-700 delay-500">
          <a
            href="https://wa.me/5579999778899?text=Olá,%20gostaria%20de%20saber%20mais%20sobre%20a%20consultoria%20jurídica."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#C6935A] hover:bg-[#A8763F] text-white font-600 px-10 py-4 rounded-full transition-all duration-300 hover:-translate-y-0.5 text-base whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-xl" />
            Solicitar Consultoria
          </a>
        </div>
      </div>
    </section>
  );
}
